<template>
	<div class="prodictImageswap"> 
	<!-- v-model="slide"  -->
	<b-carousel id="carousel-1" :interval="intervalSlider" controls indicators  background="#fff" img-width="100%" img-height="430px" style="text-shadow: 1px 1px 2px #333;"
      :no-hover-pause=true >
					 <b-carousel-slide  v-for="(data,index) in bannerItems" :key="index">
							<template #img >
							<b-link :href="data.url">
							 <!-- <img
								:src="$root.MEDIAPATH+'banners/kiwikkrrush/'+data"
								alt="image slot"
								v-bind="mainProps"
							  /> -->
							  <!--<b-img  :src="$root.MEDIAAPI+'tool/get_image?size=640x618&src='+$root.MEDIAPATH+'banners/kiwikkrrush/'+data" alt="" width="640px" class="moreOfferImgStoreHeight" ></b-img> -->
							   <!--<b-img-lazy   v-bind="mainProps" :src="$root.MEDIAAPI+'tool/get_image?size=540x450&src='+$root.MEDIAPATH+'banners/kiwikkrrush/'+data" fluid  alt="Responsive image" ></b-img-lazy>-->
							   <b-img-lazy   v-bind="mainProps" :src="$root.MEDIAPATH+'banners/kiwikkrrush/'+data.img" fluid  alt="Responsive image" ></b-img-lazy>
							  
							  </b-link>
							</template>
					  </b-carousel-slide>
					  <!--<b-carousel-slide >
						<template #img >
						<b-link href="/brand/badahair-products">
						  <img
							
							width="100%"
							max-height="280"
							:src="$root.MEDIAPATH+'banners/BADAHAIR-1.jpg'"
							alt="image slot"
							
							:class="[{'fullImage' : fullWidthImage}]" @click="fullWidthImage = !fullWidthImage"
						  />
						  </b-link>
						</template>
					  </b-carousel-slide>
					  
					  <b-carousel-slide >
						<template #img >
						<b-link href="/brand/badahair-products">
						  <img
							
							width="100%"
							max-height="280"
							:src="$root.MEDIAPATH+'banners/BADAHAIR-3.jpg'"
							alt="image slot"
							
							:class="[{'fullImage' : fullWidthImage}]" @click="fullWidthImage = !fullWidthImage"
						  />
						  </b-link>
						</template>
					  </b-carousel-slide> -->
					  
					  
						
                     
					
                       <!-- <b-carousel-slide :img-src="$root.MEDIAPATH+'banners/17a0e514-2928-418d-9050-f6e661a1ccab.jpg'"></b-carousel-slide>
						<b-carousel-slide :img-src="$root.MEDIAPATH+'banners/45c0461d-fb33-4a9f-b9fb-107d36c85153.jpg'"></b-carousel-slide>  -->
                    </b-carousel>
	
	
	
		
   </div>
    
</template>

<script>
//import AddtocartButton from "@/components/addtocartButton.vue";
export default {
  name: 'Quickview',
  props: {
    galleryimages: { type: Array }
  },
  components: {
  //"addtocart-button": AddtocartButton,
  },
  mounted(){
    //this.heading = "Related Products";
  },
  computed: {
   
  },
  data() {
  
    return{
		//thumbnailProps: { blank: false, fluidGrow: true, width: 360, height: 400,class: 'm1' },
		intervalSlider:4000,
		 fullWidthImage: false,
		 bannerItems:[		 
		 {img:'minu.jpg',title:'minu',url:'/brand/minu'},
		 {img:'disguise.jpg',title:'disguise',url:'/brand/disguise'},
		 {img:'kiwikkrrush.jpg',title:'clog-london',url:'/brand/kiwikkrrush'}
		 /*'disguise.jpg',
		 'clog-london.jpg',
		  'KKT1193.jpg',
		 'KKT22669M.jpg',
		 'KKT2675.jpg',
		'KKT2547.jpg',
		 'KKT2267G.jpg',
		 'KKT2492.jpg',
		 'KKT2489.jpg',
		 'KKT2268W.jpg',
		'KKT2266P.jpg',
		'KKT2550.jpg', */],
		 mainProps: {
          center: true,
          fluidGrow: true,
          blank: true,
          blankColor: '#fff',
          width: '590',
          height: '430',
         // class: 'my-5'
        }
    }
  },
  methods:{
		zoomMe(event){
		
		console.log('Zoom me'+event.width);
		}
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
	.prodictImageswap{
		margin-bottom: 27px;
		height:auto !important;
		.carousel-indicators {
		
		
			bottom: -35px;
			z-index: unset;
			width: 100%;
			margin-left: 0px;
			li{
				    width: 6px;
					height: 6px;
					 border-radius: 100%;
					 background-color: #000;
					 z-index: 0;
					 margin: 0px 6px;
					 border: 1px solid #fff;
				/* &:focus{ border:2px solid red;
				}*/
			}
			
			
			.expand { width:23em;/* height: 25em;*/ border:1px solid red;}
				
			
		}
		.carousel-control-next{ display:none;}
		.carousel-control-prev{ display:none;}
			 
		.carousel-item{

				box-shadow: 0 2px 3px 0 rgb(0 0 0 / 10%);
				transition: box-shadow linear 0.2s;
				padding: 4px;
				background-color: #fff;
				:hover{
				
				}
			}
		
		.fullImage {
			  width: 200%;
			  height: auto;
			}
	
		/*.swiper-wrapper{
			.padding:0px;
			.swiper-slide{
				padding:0px;
				background-color: unset;
			}
		}
		.productigDisplay{
			max-width: 100%;
			height: 400px;
		} */
		
		.img-fluid{
		    max-width: 100%;
			height: auto !important;
		}
		.w-100{
			width: auto !important;
		}
	}
	/*.swiper-priceinfo{
				min-height: 45px;
	}
			  
  .swiper-button-lock {
	display:block !important;
  } */

</style>
